import { useState , useRef , useEffect } from 'react'
import "./settings.css"



const optionData = [
{
    name:"selection Color",
    currentColor:"#ff6e61a9",
    on:true,
    property : "--selecte-row-color",
    id:1
},
{
    name:"Even Row Color",
    currentColor:"#eceaea",
    on:false,
    id:2,
    property:"--grid-even-color"
},
{
    name:"Odd Row Color",
    currentColor:"rgba(246, 239, 239, 0.748)",
    on:false,
    id:3,
    property:"--grid-odd-color"
},
{
    name:"Grid Header Color",
    currentColor:"rgba(246, 239, 239, 0.748)",
    on:false,
    id:4,
    property:"--grid-header-color"
},
]

const Settings = ( { onClose } ) => {
    const [ options , setOptions ] = useState( optionData )
    
    const [ selcetedColor , setSelcetedColor ] = useState( options.find( item => item.on ).currentColor )
    
    const handleColorChange = ( color )=>{
        setOptions( pre =>{
            return (
                pre.map( item => {
                    if( item.on )
                        return { ...item , currentColor:color }
                    return { ...item }
                } )
            )
        } )

        const selectedItem  = options.find( item => item.on )
        document.documentElement.style.setProperty(
  selectedItem.property,
  color
);
    }

    const handleSelection  = ( id )=>{
        setOptions( pre =>{
            return (
                pre.map( item => {
                    if( item.id == id ) return {...item,on:true}
                    return { ...item , on:false }
                } )
            )
        } )
    }

    useEffect(()=>{
      setSelcetedColor( options.find( item => item.on ).currentColor )
    },[options])

    useEffect(()=>{
      const rootStyles = getComputedStyle(document.documentElement);
      setOptions( pre => {
        return (
            pre.map( item => ({ ...item , currentColor:rootStyles.getPropertyValue(item.property) }) )
        )
      } )
    },[[]])

  return (
<div className="settings-con">
  <div className="settings-panel">

    {/* Left Menu */}
    <div className="settings-menu">
      {
        options.map( item => <div  key = { item.id } className={`settings-item ${item.on ? "active" : ""}`} onClick={()=>{handleSelection(item.id)}}>{ item.name }</div> )
      }
    </div>

    {/* Right Content */}
    <div className="settings-content">
      <ColorPalette selectedPlateColor = {  selcetedColor }  onSelect = { handleColorChange } />
    </div>
    
    <button onClick={()=>{onClose()}} className='icon-btn close'>
        <i class="fas fa-xmark"></i>

    </button>

  </div>
</div>


  )
}



export default Settings





const modernHues = [
  210, // blue
  220, // royal blue
  240, // indigo
  260, // purple
  280, // violet
  320, // magenta
  340, // pink
  10,  // coral
  25,  // orange
  45,  // amber
  160, // teal
  190, // cyan
];


const generateSoftColor = () => {
  const hue = modernHues[Math.floor(Math.random() * modernHues.length)];
  return `hsl(${hue}, 70%, 60%)`;
};



const generatePalette = (count = 12) => {
  const colorSet = new Set();
  let attempts = 0;
  const maxAttempts = count * 10;

  while (colorSet.size < count && attempts < maxAttempts) {
    colorSet.add(generateSoftColor());
    attempts++;
  }

  return Array.from(colorSet);
};



function ColorPalette({ onSelect , selectedPlateColor }) {
  const [colors, setColors] = useState(generatePalette());
  const [selected, setSelected] = useState(selectedPlateColor);
  const colorInputRef = useRef(null);

  const handleRegenerate = () => {
    setColors(generatePalette());
    setSelected(null);
  };

  const handleSelect = (color) => {
    setSelected(color);
    onSelect?.(color);
  };

  const handleCustomColor = (e) => {
    const color = e.target.value;
    setSelected(color);
    onSelect?.(color);
  };

  return (
    <div className="color-wrapper">

      {/* Top Left Buttons */}
      <div className="top-actions">
        <button className="icon-btn" title="Generate color" onClick={handleRegenerate}>
         <i class="fas fa-arrows-rotate"></i>
        </button>

        <button
          className="icon-btn"
          onClick={() => colorInputRef.current.click()}
          title="pick color"
        >
        <i class="fas fa-palette"></i>
          {/* <SwatchIcon width={18} /> */}
        </button>
       
        
       <button
          className="icon-btn"
          onClick={() => colorInputRef.current.click()}
          style={{background:selectedPlateColor}}
          title="Selected color"
        >
        </button>


        <input
          type="color"
          ref={colorInputRef}
          style={{ display: "none" }}
          onChange={handleCustomColor}
        />
      </div>

      {/* Color Grid */}
      <div className="color-grid">
        {colors.map((color, index) => (
          <div
            key={index}
            className={`color-box ${selected === color ? "selected" : ""}`}
            style={{ background: color }}
            onClick={() => handleSelect(color)}
          />
        ))}
      </div>
    </div>
  );
}
